module.exports = __webpack_public_path__ + "static/media/9sirpalmer.237279a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9sirpalmer.png
// module id = 108
// module chunks = 0